import {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  useQuery,
} from 'react-query';
import { useApiCredentials } from './use-api-credentials';

export function useApiQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  const { refreshToken, isTokenExpired } = useApiCredentials();

  return useQuery(
    queryKey,
    async (data) => {
      if (isTokenExpired()) {
        await refreshToken();
      }

      return queryFn(data);
    },
    options,
  );
}
